import {
    Route,
    RouterProvider,
    createHashRouter,
    createRoutesFromElements,
} from 'react-router-dom';
import Menu from './pages/Menu';
import Parametres from './pages/Parametres';
import NotFound from './components/NotFound';
import Mission from './pages/Mission';
import Game from './pages/Game';
import EndGame from './pages/EndGame';
import Code from './pages/Code';
import Quiz from './pages/Quiz';
import Map from './pages/Map';
import EnConstruction from './pages/EnConstruction';
import PagesLayout from './components/PagesLayout';
import AR from './pages/AR';
import TextTrou from './pages/Textetrou';
import Question from './pages/Question';

function Router() {
    const router = createHashRouter(
        createRoutesFromElements(
            <>
                {/* Routes AVEC PagesLayout */}
                <Route
                    path='/'
                    element={<PagesLayout />}
                >
                    <Route
                        index
                        element={<Menu />}
                    />

                    <Route
                        path='parametres'
                        element={<Parametres />}
                    />

                    <Route path='mission/:missionNumber'>
                        <Route
                            index
                            element={<Mission />}
                        />
                        <Route path='game'>
                            <Route
                                index
                                element={<Game />}
                            />
                            <Route
                                path='code'
                                element={<Code />}
                            />
                            <Route
                                path='quiz'
                                element={<Quiz />}
                            />
                            <Route
                                path='map'
                                element={<Map />}
                            />
                            <Route
                                path='texte-a-trous'
                                element={<TextTrou />}
                            />
                            <Route
                                path='question'
                                element={<Question />}
                            />
                        </Route>
                        <Route
                            path='parametres'
                            element={<Parametres />}
                        />
                        <Route
                            path='endgame'
                            element={<EndGame />}
                        />
                    </Route>

                    <Route
                        path='enconstruction'
                        element={<EnConstruction />}
                    />
                    <Route
                        path='*'
                        element={<NotFound />}
                    />
                </Route>

                {/* Route SANS PagesLayout */}
                <Route
                    path='/ar'
                    element={<AR />}
                />
            </>,
        ),
    );

    return <RouterProvider router={router} />;
}

export default Router;
